export default class Api {
  static url = "https://api.openweathermap.org";
  static key = "06f890ecc77e50e91e6cc5ecb6c1a936";
}
